import { Link } from "react-router";
import ModeButton from './modeButton.js';



function NavigationBar(props) {

    function handleClick(e) {
        props.setPage(e.target.innerHTML.toLowerCase());
    }



    return (
        <div className='headerContainer' style={{
            // marginTop: '-25px'
        }}>

<ModeButton mode = {props.mode} screenSize = {props.screenSize} handleModeSelect = {props.handleModeSelect}></ModeButton>

            <h6 style={{
                position: 'absolute',
                fontSize: '15px', 
                fontWeight: '100',  
                letterSpacing: '5px',
                color: props.mode === 'dark' ? '#f1eee6' : '#28282b',
                transition: '.5s',
                marginTop: '10px',
                marginLeft: `${props.screenSize.width - 140}px`,
               
            }}>{props.currentTime}</h6>

<h6 style={{
                position: 'absolute',
                fontSize: '15px', 
                fontWeight: '100',  
                letterSpacing: '5px',
                color: props.mode === 'dark' ? '#f1eee6' : '#28282b',
                transition: '.5s',
                marginTop: '35px',
                marginLeft: `${props.screenSize.width - 180}px`,
               
            }}>mode: {props.mode}</h6>
            

            <div className='choiceContainer' style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'flex-start', 
                paddingTop: '80px',
                rowGap: '5px',
                width: '100%'
                }}>
            <Link className='link' to='/' style={{textDecoration: (props.page === 'home') ? 'underline' : '', color: props.mode === 'dark' ? '#f1eee6' : '#28282b'}} onClick={(e) => handleClick(e)}>Home</Link>
            <Link className='link' to='/about' style={{textDecoration: (props.page === 'about') ? 'underline' : '', color: props.mode === 'dark' ? '#f1eee6' : '#28282b'}} onClick={(e) => handleClick(e)}>About</Link>
            <Link className='link' to='/contact' style={{textDecoration: (props.page === 'contact') ? 'underline' : '', color: props.mode === 'dark' ? '#f1eee6' : '#28282b'}} onClick={(e) => handleClick(e)}>Contact</Link>
            <Link className="link" to='/projects' style={{textDecoration: (props.page === 'projects') ? 'underline' : '', color: props.mode === 'dark' ? '#f1eee6' : '#28282b'}} onClick={(e) => handleClick(e)}>Projects</Link>
            </div> <br></br>

            
    
      </div>
    )
}

export default NavigationBar